(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ciento-bundle"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ciento-bundle')) {

  customElements.define(
    'ciento-bundle',
    class extends HTMLElement {

      connectedCallback() {

        if (this.initialized) return;

        this.initialized = true;


        /*
          Vi använder tre fasta platser internt.

          På desktop beter de sig som originalet.
          På mobil kan kunden välja exakt vilken
          av de tre ringarna som ska ändras.
        */

        this.selected = [
          null,
          null,
          null
        ];


        this.mobileSlot = null;

        this.busy = false;



        this.products = Array.from(
          this.querySelectorAll('[data-product]')
        ).map(card => ({

          card,

          id:card.dataset.id,

          price:Number(
            card.dataset.price
          ),

          max:Number(
            card.dataset.max
          ),

          name:
            card
              .querySelector('[data-name]')
              .textContent
              .trim(),

          image:
            card.querySelector('img')?.src

        }));



        this.issues = [];


        if (
          this.dataset.ready !== 'true'
        ) {

          this.issues.push(
            'Inställningen ”3-för-2-rabatten är aktiverad i Shopify” är avstängd. Aktivera först rabatten under Shopify → Rabatter och slå sedan på inställningen i denna sektion.'
          );

        }


        if (
          this.dataset.currency !== 'SEK'
        ) {

          this.issues.push(
            'Butikens aktuella valuta måste vara SEK. Aktuell valuta: ' +
            (this.dataset.currency || 'saknas') +
            '.'
          );

        }


        if (
          this.products.length !== 4 ||
          this.products.some(
            product => !product.id
          )
        ) {

          this.issues.push(
            'Välj en produkt i vart och ett av de fyra Parfym-blocken. En bild räcker inte.'
          );

        }


        if (
          new Set(
            this.products
              .filter(product => product.id)
              .map(product => product.id)
          ).size !==
          this.products
            .filter(product => product.id)
            .length
        ) {

          this.issues.push(
            'Välj fyra olika produkter i blocken. Kunden kan sedan välja flera av samma doft.'
          );

        }


        this.products
          .filter(
            product =>
              product.id &&
              product.price !== 29900
          )
          .forEach(product => {

            this.issues.push(
              product.name +
              ': den valda varianten kostar ' +
              (product.price / 100).toFixed(2) +
              '. Priset måste vara 299 kr för paketpriset 598 kr.'
            );

          });


        this.valid =
          this.issues.length === 0;



        this.addEventListener(
          'click',
          event => {

            const button =
              event.target.closest('button');


            if (
              !button ||
              this.busy
            ) {

              return;

            }



            /* =================================================
               DESKTOP +
               SAMMA BETEENDE SOM ORIGINAL
            ================================================= */

            if (
              button.hasAttribute('data-add')
            ) {

              if (button.disabled) return;


              const index =
                Number(
                  button.dataset.add
                );


              const emptySlot =
                this.selected.indexOf(null);


              if (
                emptySlot !== -1 &&
                this.products[index]?.id &&
                this.count(index) <
                  this.products[index].max
              ) {

                this.selected[
                  emptySlot
                ] = index;

              }


              this.render();

              return;

            }



            /* =================================================
               DESKTOP -
            ================================================= */

            if (
              button.hasAttribute('data-remove')
            ) {

              if (button.disabled) return;


              const index =
                Number(
                  button.dataset.remove
                );


              const position =
                this.selected.lastIndexOf(
                  index
                );


              if (
                position !== -1
              ) {

                this.selected[
                  position
                ] = null;


                this.compactSelection();

              }


              this.render();

              return;

            }



            /* =================================================
               DE TRE RUNDA RINGARNA
            ================================================= */

            if (
              button.hasAttribute('data-slot')
            ) {

              const slot =
                Number(
                  button.dataset.slot
                );


              /*
                MOBIL:
                öppna väljaren.
              */

              if (
                window.innerWidth <= 600
              ) {

                this.openMobilePicker(
                  slot
                );

                return;

              }


              /*
                DESKTOP:
                originalbeteende.
                Klick = ta bort.
              */

              if (
                this.selected[
                  slot
                ] !== null
              ) {

                this.selected[
                  slot
                ] = null;


                this.compactSelection();


                this.render();

              }


              return;

            }



            /* =================================================
               MOBIL:
               VÄLJ PARFYM
            ================================================= */

            if (
              button.hasAttribute(
                'data-mobile-product'
              )
            ) {

              if (
                button.disabled ||
                this.mobileSlot === null
              ) {

                return;

              }


              const productIndex =
                Number(
                  button.dataset.mobileProduct
                );


              const product =
                this.products[
                  productIndex
                ];


              if (!product) return;


              const currentProduct =
                this.selected[
                  this.mobileSlot
                ];


              /*
                Samma parfym får väljas
                på flera platser.
              */

              if (
                currentProduct !== productIndex &&
                this.count(productIndex) >=
                  product.max
              ) {

                return;

              }


              this.selected[
                this.mobileSlot
              ] = productIndex;


              this.closeMobilePicker();


              this.render();

              return;

            }



            /* =================================================
               STÄNG MOBILVÄLJAREN
            ================================================= */

            if (
              button.hasAttribute(
                'data-picker-close'
              )
            ) {

              this.closeMobilePicker();

              return;

            }



            /* =================================================
               ADD TO CART
            ================================================= */

            if (
              button.hasAttribute(
                'data-submit'
              )
            ) {

              if (button.disabled) return;


              this.submit();

              return;

            }

          }
        );


        this.render();

      }



      /* ===================================================
         ANTAL AV EN PARFYM
      =================================================== */

      count(index) {

        return this.selected
          .filter(
            value =>
              value === index
          )
          .length;

      }



      /* ===================================================
         ANTAL VALDA TOTALT
      =================================================== */

      selectedCount() {

        return this.selected
          .filter(
            value =>
              value !== null
          )
          .length;

      }



      /* ===================================================
         DESKTOP:
         FLYTTA IHOP VALEN EFTER BORTTAGNING
      =================================================== */

      compactSelection() {

        const selected =
          this.selected.filter(
            value =>
              value !== null
          );


        while (
          selected.length < 3
        ) {

          selected.push(null);

        }


        this.selected =
          selected.slice(0,3);

      }



      /* ===================================================
         ÖPPNA MOBILVÄLJARE
      =================================================== */

      openMobilePicker(slot) {

        this.mobileSlot =
          slot;


        const picker =
          this.querySelector(
            '[data-mobile-picker]'
          );


        const title =
          this.querySelector(
            '[data-picker-title]'
          );


        if (title) {

          title.textContent =
            `Doft ${slot + 1}`;

        }


        if (picker) {

          picker.hidden =
            false;

        }


        this.render();

      }



      /* ===================================================
         STÄNG MOBILVÄLJARE
      =================================================== */

      closeMobilePicker() {

        this.mobileSlot =
          null;


        const picker =
          this.querySelector(
            '[data-mobile-picker]'
          );


        if (picker) {

          picker.hidden =
            true;

        }

      }



      /* ===================================================
         RENDER
      =================================================== */

      render() {

        const selectedCount =
          this.selectedCount();



        /* =================================================
           ORIGINAL DESKTOP PRODUKTKNAPPAR
        ================================================= */

        this.products.forEach(
          (product,index) => {

            const count =
              this.count(index);


            const counter =
              product.card.querySelector(
                '[data-count]'
              );


            if (counter) {

              counter.textContent =
                count;

            }


            const add =
              product.card.querySelector(
                '[data-add]'
              );


            const remove =
              product.card.querySelector(
                '[data-remove]'
              );


            if (add) {

              add.disabled =
                this.busy ||
                !product.id ||
                selectedCount >= 3 ||
                count >= product.max;

            }


            if (remove) {

              remove.disabled =
                this.busy ||
                count === 0;

            }

          }
        );



        /* =================================================
           TRE RUNDA RINGAR
        ================================================= */

        this.querySelectorAll(
          '[data-slot]'
        ).forEach(
          (button,index) => {

            const selectedIndex =
              this.selected[
                index
              ];


            const product =
              selectedIndex !== null
                ? this.products[
                    selectedIndex
                  ]
                : null;


            button.replaceChildren();



            if (
              product?.image
            ) {

              const img =
                document.createElement(
                  'img'
                );


              img.src =
                product.image;


              img.alt =
                product.name;


              button.append(img);

            }

            else {

              const span =
                document.createElement(
                  'span'
                );


              span.textContent =
                index + 1;


              button.append(span);

            }



            /*
              På mobil ska även tomma
              ringar vara klickbara.

              På desktop gäller
              originalbeteendet.
            */

            if (
              window.innerWidth <= 600
            ) {

              button.disabled =
                this.busy;

            }

            else {

              button.disabled =
                this.busy ||
                !product;

            }



            if (
              window.innerWidth <= 600
            ) {

              button.setAttribute(
                'aria-label',

                product

                  ? `Byt ${product.name} på plats ${index + 1}`

                  : `Välj parfym för plats ${index + 1}`
              );

            }

            else {

              button.setAttribute(
                'aria-label',

                product

                  ? `Ta bort ${product.name} från paketet`

                  : `Tom plats ${index + 1}`
              );

            }



            const slotName =
              button
                .parentElement
                .querySelector(
                  '[data-slot-name]'
                );


            if (slotName) {

              slotName.textContent =
                product?.name ||
                `Doft ${index + 1}`;

            }

          }
        );



        /* =================================================
           MOBILALTERNATIVEN
        ================================================= */

        this.querySelectorAll(
          '[data-mobile-product]'
        ).forEach(
          button => {

            const productIndex =
              Number(
                button.dataset.mobileProduct
              );


            const product =
              this.products[
                productIndex
              ];


            const existing =
              this.mobileSlot !== null

                ? this.selected[
                    this.mobileSlot
                  ]

                : null;


            const icon =
              button.querySelector(
                '.cb__mobile-plus'
              );



            if (
              existing === productIndex
            ) {

              button.classList.add(
                'is-selected'
              );


              if (icon) {

                icon.textContent =
                  '✓';

              }

            }

            else {

              button.classList.remove(
                'is-selected'
              );


              if (icon) {

                icon.textContent =
                  '+';

              }

            }



            button.disabled =
              this.busy ||
              !product?.id ||
              (
                existing !== productIndex &&
                this.count(productIndex) >=
                  product.max
              );

          }
        );



        /* =================================================
           PROGRESS
        ================================================= */

        const progress =
          this.querySelector(
            '.cb__progress'
          );


        if (progress) {

          progress.textContent =
            `${selectedCount} av 3 valda`;

        }



        /* =================================================
           KÖPKNAPP
        ================================================= */

        const submit =
          this.querySelector(
            '[data-submit]'
          );


        submit.disabled =
          this.busy ||
          !this.valid ||
          selectedCount !== 3;



        if (
          this.busy
        ) {

          submit.textContent =
            'Öppnar kassan…';

        }

        else if (
          selectedCount < 3
        ) {

          const remaining =
            3 - selectedCount;


          submit.textContent =

            remaining === 1

              ? 'Välj 1 doft till'

              : `Välj ${remaining} dofter till`;

        }

        else if (
          !this.valid
        ) {

          submit.textContent =
            'Paketet är inte tillgängligt just nu';

        }

        else {

          submit.textContent =
            'Gå till kassan – 598 kr';

        }



        const setupMessage =
          this.querySelector(
            '[data-setup-message]'
          );


        if (setupMessage) {

          setupMessage.hidden =
            this.valid;

        }



        const diagnostics =
          this.querySelector(
            '[data-diagnostics]'
          );


        if (diagnostics) {

          diagnostics.textContent =

            this.issues.length

              ? 'Åtgärda innan försäljning: ' +
                this.issues.join(' ')

              : 'Inställningarna är klara. Kontrollera att tre parfymer kostar 598 kr i kassan. Sektionen kan inte kontrollera om Shopify-rabatten är aktiv.';

        }

      }



      /* ===================================================
         ADD TO CART
      =================================================== */

      async submit() {

        if (
          this.busy ||
          !this.valid ||
          this.selectedCount() !== 3
        ) {

          return;

        }


        this.busy =
          true;


        this.render();


        const error =
          this.querySelector(
            '[data-error]'
          );


        error.hidden =
          true;



        const items =
          this.products

            .map(
              (product,index) => ({

                id:
                  product.id,

                quantity:
                  this.count(index)

              })
            )

            .filter(
              item =>
                item.quantity > 0
            );



        try {

          const response =
            await fetch(
              this.dataset.addUrl,
              {

                method:'POST',

                headers:{
                  'Content-Type':'application/json',
                  'Accept':'application/json'
                },

                body:
                  JSON.stringify({
                    items
                  })

              }
            );


          if (
            !response.ok
          ) {

            throw new Error(
              'cart'
            );

          }


          window.location.assign(
            '/checkout'
          );

        }

        catch (_) {

          error.replaceChildren(
            document.createTextNode(
              'Det gick inte att bekräfta att hela paketet lades till. Kontrollera varukorgen innan du försöker igen. '
            )
          );


          const link =
            document.createElement(
              'a'
            );


          link.href =
            this.dataset.cartUrl;


          link.textContent =
            'Visa varukorgen';


          error.append(
            link
          );


          error.hidden =
            false;


          this.busy =
            false;


          this.render();

        }

      }

    }
  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
